<template>
  <div>
    <select-base
      ref="base"
      v-model="valueInner"
      :disabled="disabled"
      :multiple="multiple"
      :invalido="invalido"
      :require="requireUsuario"
      :label="label"
      :label-select="'nomeCompleto'"
      :carregar="carregarUsuarios"
      :filtro-adicional="filtroAdicional"
      :placeholder="placeholder"
      :ignorar-primeiro-acesso="ignorarPrimeiroAcesso"
      @input="enviarParaPai"
    />
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import api from '@/app-modulo/comuns/usuario-interno/shared/services/api'
import '@core/scss/vue/libs/vue-select.scss'

export default {
  name: 'UsuarioInternoSelect',
  components: {
    SelectBase: () => import('@/shared/components/select-base/SelectBase.vue'),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    invalido: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Object, Array],
      default: () => { },
    },
    departamento: {
      type: Number,
      default: null,
    },
    label: {
      type: String,
      default: 'Usuário',
    },
    filtroAdicional: {
      type: Function,
      default: () => null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    requireUsuario: {
      type: Boolean,
      default: false,
    },
    apenasAtivos: {
      type: Boolean,
      default: true,
    },
    ignorarPrimeiroAcesso: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value_: null,
      filtros: [
        {
          colunas: ['NomeCompleto'],
          valor: '',
        },
      ],
    }
  },
  computed: {
    valueInner: {
      set(value) {
        this.value_ = value
      },
      get() {
        return this.value_
      },
    },
  },
  watch: {
    departamento(value, oldValue) {
      if (value !== oldValue) {
        if (this.filtros.length === 2) {
          this.filtros[1].valor = value
        } else {
          this.filtros.push({
            colunas: ['Departamento'],
            valor: value,
          })
        }
        this.$refs.base.carregarItensFiltrados('')
      }
    },
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
      }
    },
  },
  created() {
    this.valueInner = this.value
  },
  methods: {
    carregarUsuarios() {
      if (this.filtros.length === 1 && this.departamento > 0) {
        this.filtros.push({
          colunas: ['Departamento'],
          valor: this.departamento,
        })
      }
      return api.getUsuariosResumidos(this.filtros, this.apenasAtivos)
    },
    enviarParaPai() {
      this.$emit('input', this.valueInner)
    },
  },
}
</script>
